<app-custom-betty-report-filters [showReportDropDown]="true" (reportType)="getReportType($event)"
    (customLoanGroups)="getCustomLoanGroups($event)" [showLoanStatus]="true" (loanStatus)="selectedLoanStatus($event)"
    [showBreakdowns]="false" [showCurrentDate]="false" [showDateRange]="true" (start_date)="startDate($event)"
    (end_date)="endDate($event)" [btnColor]="'primary'" [btnShowText]="btnShowText" [btnText]="'Submit'"
    [btnSpinner]="btnSpinner" (onBtnClick)="downloadDailyReconReport()">
</app-custom-betty-report-filters>
<h5 style="margin-left: 20px;">Total Funded: {{Display_Funded_Amount | currency}} | Total SAHA: {{total_saha_law |
    currency}} | Total Referral: {{total_agency_referral | currency}}</h5>
<div class="row" style="height: calc(100% - 175px); margin: 10px;">
    <app-custom-table class="ag-theme-material" [rowData]="rowData_Hist" [columnDefs]="columnDefs_Hist"
        [defaultExcelExportParams]="defaultExcelExportParams" [defaultCsvExportParams]="defaultCsvExportParams"
        [hideGlobalFilter]="true" [animateRows]="true" [pagination]="true" [paginationPageSize]="100"
        (gridReady)="onGridReady_Hist($event)">
    </app-custom-table>
</div>